<template>
  <!-- Figma notes box (S&R Details card / Job Details "Internal Notes"): 1px #CCCCCC box, note bubbles, input row at the bottom -->
  <div v-if="isAccordionOpen || !isMobile" class="notes font-roboto">
    <p v-if="heading" class="m-0 mb-[10px] text-[16px] font-bold text-[#333333]">
      {{ heading }}
    </p>
    <div
      class="flex flex-col laptop:min-h-[267px] max-h-[400px] border-1 border-[#CCCCCC] rounded-[10px] bg-white p-[5px]">
      <ul class="flex-1 overflow-y-auto list-none m-0 p-[5px] flex flex-col gap-[10px]">
        <li v-for="(item, index) in bookingNotes" :key="index">
          <!-- own notes grey, others white with a border -->
          <div class="relative rounded-[10px] p-[10px] pr-[26px] text-[12px] text-[#333333] break-words"
            :class="isOwn(item) ? 'bg-[#EFEFEF]' : 'bg-white border-1 border-[#EFEFEF]'">
            <p v-if="item.sub_type_text" class="m-0 mb-[2px] font-medium">
              {{ item.sub_type_text }}
            </p>
            <p class="m-0 leading-[14px] font-roboto text-[12px]" v-html="getNotesTxt(item.notes)" />
            <button v-if="isOwn(item)" type="button"
              class="absolute right-[10px] -bottom-[10px] p-0 leading-none w-[26px] h-[26px] rounded-full flex items-center justify-center border !border-[#EFEFEF] text-[#F67280] !bg-[#fff] hover:text-[#fff] hover:!bg-[#F67280]"
              aria-label="Delete note" @click="deleteNotesClicked(item)">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
                class="w-[13px] h-[13px]">
                <path d="M0 0h24v24H0z" fill="none" />
                <path fill="currentColor" fill-rule="evenodd"
                  d="M9.774 5L3.758 3.94l.174-.986a.5.5 0 0 1 .58-.405L18.411 5h.088h-.087l1.855.327a.5.5 0 0 1 .406.58l-.174.984l-2.09-.368l-.8 13.594A2 2 0 0 1 15.615 22H8.386a2 2 0 0 1-1.997-1.883L5.59 6.5h12.69zH5.5zM9 9l.5 9H11l-.4-9zm4.5 0l-.5 9h1.5l.5-9zm-2.646-7.871l3.94.694a.5.5 0 0 1 .405.58l-.174.984l-4.924-.868l.174-.985a.5.5 0 0 1 .58-.405z" />
              </svg>
            </button>
          </div>
          <p class="m-0 mt-[4px] px-[2px] text-[10px] text-[#999999]">
            {{ convertNotesTimsStampToDate(item.created_at) }}
          </p>
        </li>
        <li v-if="!bookingNotes || !bookingNotes.length" class="py-4 text-center text-[12px] text-[#999999]">
          No notes yet
        </li>
      </ul>
      <div
        class="flex items-center gap-2 h-[40px] mt-[5px] rounded-[10px] bg-white shadow-[0px_0px_20px_0px_#00000026] pl-[10px] pr-[5px]">
        <input v-model="note" type="text"
          class="flex-1 min-w-0 border-0 outline-none bg-transparent text-[14px] text-[#333333] placeholder:text-[#666666]"
          placeholder="Write your Notes..." @keyup.enter="addNoteButtonClicked()">
        <button type="button"
          class="w-[30px] h-[30px] flex-shrink-0 rounded-[6px] bg-[#EFEFEF] border-0 flex items-center justify-center"
          :class="sendButtonDisable() ? 'opacity-50' : ''" :disabled="sendButtonDisable()" aria-label="Send note"
          @click="addNoteButtonClicked()">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16">
            <path d="M0 0h16v16H0z" fill="none" />
            <defs>
              <path id="SVG2jlUvrhl"
                d="M12.97 2.67a.5.5 0 0 0-.64-.64l-11 4a.5.5 0 0 0-.016.934l4.433 1.773l2.9-3.09l.707.707l-2.98 3.176l1.662 4.156a.5.5 0 0 0 .934-.015z" />
            </defs>
            <g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd">
              <use href="#SVG2jlUvrhl" />
              <use href="#SVG2jlUvrhl" />
            </g>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import { useToast } from 'vue-toastification';
const toast = useToast();

export default {
  // heading: title above the box ("Add Notes" in the evaluation Details card)
  props: ["isFromJobDetail", "heading"],
  data() {
    return {
      note: "",
      isAccordionOpen: true,
      isMobile: false,
      user: {},
      user_id: null
      // bookingNotes: [],
    };
  },

  computed: {
    ...mapGetters(["bookingNotes", "deleteNoteResponse", "addNoteResponse"]),
  },

  watch: {
    deleteNoteResponse: function () {
      this.getBookingNotes({
        booking_id: this.$route.params.id,
      });
    },

    addNoteResponse: function () {
      this.note = "";
      this.getBookingNotes({
        booking_id: this.$route.params.id,
      });
    },
  },

  mounted() {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.user_id = this.user.user.user_id;
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.checkMobile);
  },

  methods: {
    ...mapActions(["deleteBookingNote", "getBookingNotes", "addBookingNote"]),

    isOwn(item) {
      return Number(item.sender_id) === Number(this.user_id);
    },

    getNotesTxt(note) {

      return note.replace("\n", "<br>")
    },

    deleteNotesClicked(data) {
      this.$dialog.show({
        title: "Delete Notes",
        text: "Are you sure you want to delete this note?",
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.deleteBookingNote({
            note_id: data.id,
            booking_id: this.$route.params.id,
          });
        },
      });
    },

    addNoteButtonClicked() {
      if ((this.note + "").trim().length > 0) {
        this.addBookingNote({
          notes: this.note,
          booking_id: this.$route.params.id,
        });
      } else {
        toast.error("Notes field is required");
        this.note = ''
      }
    },

    sendButtonDisable() {
      let res = true
      if ((this.note + "").trim().length > 0) {
        res = false
      }
      return res
    },

    convertNotesTimsStampToDate(val) {
      return moment.unix(val).format("MM/DD/YYYY hh:mm A");
    },

    toggleAccordion() {
      this.isAccordionOpen = !this.isAccordionOpen;
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 767;
    },
  },
};
</script>

<style>
.accordion-icon {
  transition: transform 0.3s;
  color: #fff;
  font-size: 20px;
}

.accordion-icon.rotated {
  transform: rotate(180deg);
}

button.border-0.p-0.disable img {
  opacity: 0.5;
}

@media (min-width: 768px) {

  /* .notesBody {
    display: none;
  }
  .notesBody[open] {
    display: block;
  } */
  .accordion-icon {
    display: none;
  }
}
</style>
